/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import { Type } from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import { AbstractForm } from "../../../tools/model/form/AbstractForm";
import { ClientClientDTO } from "../../dto/client/ClientClientDTO";
import { SelectField } from "../../../tools/model/form/SelectField";
import { Selectable } from "../../../tools/model/form/Selectable";
import Client from "../../Client";

export default class ClientClientForm extends AbstractForm<ClientClientDTO> {
    constructor(client: Client, clients: Client[]) {
        super();

        let selectableValues: Array<Selectable<string>> = clients.map(client => {
            return { value: client.id, name: client.name, disabled: false };
        })

        this.fields.set(ClientClientDTO.CLIENT_IDS, new SelectField(
            selectableValues,
            ClientClientDTO.CLIENT_IDS,
            (t: Translation) => t.clients,
            () => true,
            Type.SELECT,
            true,
            true,
            [],
            []
        ));

        this.load(ClientClientDTO.fromClient(client));
    }
}
